<nw-content-block [transparentBackground]="true">
    <div class="nw-video-block__container">
        @if (videourl || thumbnail) {
            <div class="nw-video-block__container__video">
                <nw-video
                    [videoUrl]="videourl"
                    [thumbnail]="thumbnail"
                    [altText]="videoalternativetext"
                    [duration]="videoduration"
                ></nw-video>
            </div>
        }
    </div>
</nw-content-block>
